<template>
  <div>
    <div class="summary-list">
      <div class="summary-item"
          v-for="(item, index) in summaryList"
          :key="index"
        >
          <div class="title">{{ item.name }}</div>
          <div class="amount">{{ item.amount }}</div>
      </div>
    </div>
    <div class="driversbill-tip" v-if="rulesList.length">
      <div>租金规则</div>
      <p v-for="(item, index) in rulesList" :key="index">
        {{ item.conditionMinValue }} ≤ {{ item.conditionName }} < {{ item.conditionMaxValue }}, 租金{{ item.rent }}元/每期;
      </p>
    </div>
    <QS-common-table
      :data="tableData"
      :columns="tableListColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
      v-loading="tableLoading"
    />
    <receivepaymentDetail ref="detail" />
    <!-- 发起支付宝支付 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <alipayWithholdDialogNew @executeSuccess="getPageInfo()" ref="alipayWithholdDialogNewRef" />
  </div>
</template>
<script>
import { dynamicRentRuleInfo, orderDriverBillInfo, orderDriverBillSummary } from '@/api/domain/orders'
import { getCollectionRecordList } from '@/api/financeApi'
import alipayWithholdDialogNew from '@/pages/orders/components/alipayWithholdDialogNew.vue'
import { config } from './driversbillConfig.js'
import receivepaymentDetail from './receivepaymentDetail.vue'

export default {
  name: 'driversbill',
  props: {
    orderId: {
      type: [Number, String],
    },
    rentCategory: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    receivepaymentDetail,
    alipayWithholdDialogNew,
  },
  data() {
    const { tableColumns } = config.call(this)
    return {
      tableData: [],
      tableColumns,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      tableLoading: false,
      rulesList: [],
      summaryList: [
        {
          name: '应收总额',
          key: 'totalReceivableAmount',
          amount: 0,
        },
        {
          name: '收款中+已收款总额',
          key: 'receivedAmount',
          amount: 0,
        },
        {
          name: '剩余应收金额',
          key: 'toReceivableAmount',
          amount: 0,
        },
      ],
    }
  },
  created() {
    this.getPageInfo()
  },
  activated() {
    this.getPageInfo()
  },
  computed: {
    tableListColumns() {
      if (this.rulesList.length === 0) {
        return this.tableColumns.filter((item) => item.name !== 'finishOrderCount')
      }
      return this.tableColumns
    },
  },
  methods: {
    // 收款详情
    // eslint-disable-next-line vue/no-unused-properties
    paymentDetail(row) {
      this.$refs.detail.open(this.orderId, row.receivableIds)
    },
    // 线下收款
    // eslint-disable-next-line vue/no-unused-properties
    async offlinePayment(row) {
      if (row.receivableIds) {
        const { code } = await getCollectionRecordList({ ids: row.receivableIds.split(',') })
        if (code === 1) {
          this.$router.push({
            path: '/workbench/batchCollectionRecordAdd',
            query: {
              paymentIds: row.receivableIds,
              type: 'order',
              approvalOrigin: 4,
            },
          })
        }
      }
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getDriversbill()
    },
    // 司机账单
    async getDriversbill() {
      const { code, data } = await orderDriverBillInfo({
        orderId: this.orderId,
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
      })

      if (code === 1) {
        this.tableData = (data?.items || []).map((item) => ({
          ...item,
          rentCategory: this.rentCategory,
        }))
        this.paginationData.total = data?.totalNum || 0
      }
    },
    // 司机账单汇总
    async getDriverBillSummary() {
      const { code, data } = await orderDriverBillSummary({ orderId: this.orderId })
      if (code === 1) {
        this.summaryList = this.summaryList.map((item) => ({
          ...item,
          amount: data[item.key] || 0,
        }))
      }
    },
    async getDynamicRentRuleInfo() {
      const { code, data } = await dynamicRentRuleInfo({ orderId: this.orderId })
      if (code === 1) {
        this.rulesList = data?.detailList || []
      }
    },
    getPageInfo() {
      this.getDynamicRentRuleInfo()
      this.getDriversbill()
      this.getDriverBillSummary()
    },
  },
}
</script>
<style lang="scss" scoped>
.driversbill-tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 20px 0;
  div {
    font-size: 14px;
  }
  p {
    font-weight: 500;
    font-size: 14px;
  }
}
.summary-list {
  display: flex;
  gap: 16px;
  .summary-item {
    width: 400px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    .title {
      margin-bottom: 8px;
    }
    .amount {
      font-weight: 600;
      color: #333;
    }
  }
}
</style>
